<script setup lang="ts">
import { PropType } from 'vue';

import type { TenantConfig } from '@/shared/interfaces/tenant';
import useUtils from '@/shared/composables/useUtils';
import { Currency } from '@/shared/interfaces/balance';
import { GroupedTransactions } from '@/shared/interfaces/wallet';
import { useI18n } from 'vue-i18n';

const props = defineProps({
	date: { type: String, required: true },
	hideTransactionSign: { type: Boolean },
	price: { type: Number, required: true },
	priceDetail: { type: Object as PropType<GroupedTransactions>, required: false },
	currency: { type: Object as PropType<Currency>, required: false },
	transactionType: { type: String },
	paymentType: { type: String },
	tenantConfig: { type: Object as PropType<TenantConfig>, required: true },
});

// Init
const { t } = useI18n();
const { convertToCurrency } = useUtils();
</script>

<template>
	<div class="flex grow flex-col items-end">
		<div class="flex">
			<div v-for="(transactionGroup, index) in Object.values(props.priceDetail || {})" :key="index" class="font-sourcesanspro-semibold text-sm2 text-nowrap ml-2" :class="props.transactionType === 'CREDIT' ? 'text-anykrowd-green' : 'text-anykrowd-red'">
				<span>{{ transactionGroup.prefix }} {{ convertToCurrency(+transactionGroup.totalAmount) }}</span>
			</div>

			<div v-if="props.paymentType === 'top_up_cost'" class="font-sourcesanspro-semibold text-sm2 text-nowrap ml-2" :class="props.transactionType === 'CREDIT' ? 'text-anykrowd-green' : 'text-anykrowd-red'">
				<span>&euro; {{ convertToCurrency(+(props.price * -1)) }}</span>
			</div>
		</div>
		<span class="font-sourcesanspro-regular text-xs font-color-text-50 leading-none whitespace-nowrap">
			{{ props.date }}
		</span>
	</div>
</template>

<style scoped></style>
